import { useCallback } from 'react'
import { CIMSSingleColumn } from '../../../CIMSColumn/types'
import { getWidth } from './utils/getWidth'

export function useGetWidth<T>(records: T[] | undefined) {
  return useCallback(
    (width: CIMSSingleColumn<T>['width']) => {
      if (typeof width === 'object')
        return (records?.length ?? 0) > 0
          ? getWidth(records, width.withRecords)
          : getWidth(records, width.withoutRecords)
      else if (width) return getWidth(records, width)
      return undefined
    },
    [records]
  )
}
